import { ChangeEvent } from 'react'

interface ToggleProps {
  enabled: boolean
  onToggle: (newEnabled: boolean) => void
}

export const Toggle = ({ enabled, onToggle }: ToggleProps) => {
  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    onToggle(event.target.checked)
  }

  return (
    <label className="inline-flex cursor-pointer items-center">
      <input
        type="checkbox"
        value=""
        className="peer sr-only"
        checked={enabled}
        onChange={handleChange}
      />

      <div
        className="peer-checked:border-blue peer relative h-5 w-9
          rounded-full border-2 border-black
          after:absolute after:start-[5px] after:top-[2px] after:h-3
          after:w-3 after:rounded-full
          after:border after:border-black after:bg-black
          after:transition-all after:content-[''] peer-checked:border-[#407BFF]
          peer-checked:bg-white peer-checked:after:translate-x-full
          peer-checked:after:border-[#407BFF] peer-checked:after:bg-[#407BFF] peer-focus:outline-none
          rtl:peer-checked:after:-translate-x-full"
      />
    </label>
  )
}
